/**
* 震动金锁锁 远程控制
*/
<template>
	<div>
		<link href="https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css" rel="stylesheet">
		<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css">

		<!-- 数据加载提示框 -->
		<van-overlay :show="isDataLoading" @click="show = false">
			<div style="display: flex;align-items: center;justify-content: center; height: 100%;" @click.stop>
				<van-loading size="24px" vertical>{{ $t('language000053') }}</van-loading>
			</div>
		</van-overlay>

		<div class="min-h-screen bg-gray-50 pb-20">
			<div class="fixed top-0 w-full bg-white shadow-md z-50 px-4 py-3">
				<button @click="queryPruchasedPackages"
					:class="[ '!rounded-button w-full py-3 flex items-center justify-center gap-2',isConnected ? 'bg-green-500 text-white' : 'bg-red-500 text-white']">
					<i :class="['fas', isConnected ? 'fa-link' : 'fa-unlink']"></i>
					{{ isConnected ? $t('language000421') : $t('language000422') }}
				</button>
			</div>

			<!-- 开锁关锁 -->
			<div class="lock-control-container" v-show="false">
				<div class="lock-control-content">
					<div >
						<h1 class="status-text" :class="lockStatus ? 'status-text-locked' : 'status-text-unlocked'">
							{{ lockStatus ? '已关锁' : '已开锁' }}
						</h1>
					</div>

					<div class="button-area">
						<button @click="handleUnlock" :disabled="!lockStatus" class="control-button open-button"
							:class="{ 'button-disabled': !lockStatus }">
							<div class="button-content">
								<i class="fas fa-lock-open icon"></i>
								<span class="button-label">开锁</span>
							</div>
						</button>

						<button @click="handleLock" :disabled="lockStatus" class="control-button close-button"
							:class="{ 'button-disabled': lockStatus }">
							<div class="button-content">
								<i class="fas fa-lock icon"></i>
								<span class="button-label">关锁</span>
							</div>
						</button>
					</div>
				</div>

				<div v-if="showConfirmDialog" class="confirm-dialog-overlay">
					<div class="confirm-dialog-box">
						<h3 class="dialog-title">确认操作</h3>
						<p class="dialog-message">确定要{{ confirmAction }}吗？</p>
						<div class="dialog-actions">
							<button @click="showConfirmDialog = false" class="dialog-button cancel-button">
								取消
							</button>
							<button @click="confirmOperation" class="dialog-button confirm-button">
								确认
							</button>
						</div>
					</div>
				</div>
			</div>


			<!-- 震动选项 -->
			<div class="pt-20 px-4" :class="{ 'opacity-50 pointer-events-none': !isConnected }">
				<div class="bg-white rounded-xl shadow-sm p-4 mb-4">
					<h2 class="text-lg font-medium mb-4">
						<!-- 模式选择 -->
						{{ $t('language000423') }}
					</h2>

					<div class="mb-6">
						<div class="flex items-center justify-between mb-4">
							<span class="text-base">
								<!-- 震动模式 -->
								{{ $t('language000424') }}
							</span>

							<el-switch style="display: block" @change="toggleVibration" v-model="vibrationEnabled"
								active-color="#13ce66" inactive-color="#999" :active-text="$t('language000363')">
							</el-switch>

						</div>

						<div class="grid grid-cols-5 gap-2 mb-4">
							<button v-for="mode in 5" :key="`vib-${mode}`" @click="selectVibrationMode(mode)"
								:class="[ '!rounded-button py-2 text-sm', vibrationMode === mode ? 'bg-blue-500 text-white' : 'bg-gray-100' ]">
								<!-- 模式选择 -->
								{{ $t('language000423') }}{{ mode }}
							</button>
						</div>

						<div class="px-2">
							<input type="range" v-model="vibrationIntensity" min="1" max="5"
								class="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer">
							<div class="flex justify-between text-xs text-gray-500 mt-1">
								<span>1</span>
								<span>2</span>
								<span>3</span>
								<span>4</span>
								<span>5</span>
							</div>
						</div>
					</div>

				</div>

				<div class="bg-white rounded-xl shadow-sm p-4">
					<h2 class="text-lg font-medium mb-4">
						<!-- 线性控制 -->
						{{ $t('language000426') }}
					</h2>

					<div class="mb-6">
						<div class="flex items-center justify-between mb-4">
							<span class="text-base">
								<!-- 震动强度 -->
								{{ $t('language000427') }}
							</span>

							<el-switch style="display: block" @change="linearOpening" v-model="linearVibrationEnabled"
								active-color="#13ce66" inactive-color="#999" :active-text="$t('language000363')">
							</el-switch>

						</div>

						<div class="px-2">
							<input type="range" @input="handleLinearVibrationChange" v-model="linearVibrationIntensity"
								min="1" max="100"
								class="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer">
							<div class="flex justify-between text-xs text-gray-500 mt-1">
								<span>1</span>
								<span>25</span>
								<span>50</span>
								<span>75</span>
								<span>100</span>
							</div>
						</div>
					</div>
				</div>


			</div>
		</div>
	</div>
</template>

<script>
	import Cookies from 'js-cookie';
	import axios from 'axios';

	export default {
		data() {
			return {
				isDataLoading: false, //加载数据提示框
				toyId: "", //传递过来的值 设备ID
				receiverID: "", //传递过来的值 生成链接的ID
				uuid: "", //传递过来的值 uuid 唯一标识
				isConnected: false, //设备是否成功连接

				vibrationEnabled: false, //长摇尾部 是否开启
				vibrationMode: 1, //震动模式1~5
				vibrationIntensity: 1, //震动力度1~5

				linearVibrationEnabled: false, //线性尾部 是否开启
				linearVibrationIntensity: 1, //线性力度

				linearSuctionEnabled: false, //线性头部 是否开启
				linearSuctionIntensity: 1, //线性力度

				command: "", //发送给APP的蓝牙命令

				lockStatus: true, // true 表示已关锁，false 表示已开锁
				showConfirmDialog: false,
				confirmAction: '',
				pendingOperation: null,
			};
		},
		mounted() {
			this.toyId = this.$route.params.toyId; //设备ID
			this.receiverID = this.$route.params.receiverID; //生成链接的ID
			this.uuid = this.$route.params.uuid; //uuid 唯一标识

			const userLanguage = navigator.language || navigator.userLanguage;
			const isLanguageSupported = this.$p_languages.includes(userLanguage);
			this.$i18n.locale = isLanguageSupported ? userLanguage : this.$p_defaultLanguage;
		},
		methods: {
			queryPruchasedPackages() { //H5查询App是否已连接设备
				//this.isDataLoading = true;
				axios.post(this.$p_url + '/feign/toyShakeMetalLockBluetooth/h5/getAppConnectToyStatus/' + this.toyId, {}, {
						withCredentials: true,
						headers: {
							'Content-Type': 'application/json',
							'Accept': '*/*',
							'token': Cookies.get("token"),
						},
					})
					.then(response => {
						this.isDataLoading = false;
						console.log("H5查询App是否已连接设备：", response.data)
						const state = response.data.state; // 获取状态
						if (state === "success") { // 检查状态
							if (response.data.data.appConnectStatus == 0) { //app端连接设备的状态 默认0未连接，1已连接
								this.open4(this.$t('language000429')); //APP未连接设备
								this.isConnected = false;
							}
							if (response.data.data.appConnectStatus == 1) { //app端连接设备的状态 默认0未连接，1已连接
								this.isConnected = true;
								this.pushMsgToApp("mqtt_h5_100001") //推送
							}
						}
					})
					.catch(error => { // 请求失败时处理错误
						this.isDataLoading = false;
						console.error('Error fetching data:', error);
					});
			},
			//----------------------------------------------------------------------------------------------------------------------------------------------
			//开锁关锁
			updateStatus(isLocked) {
				this.lockStatus = isLocked;
				const currentTime = new Date().toLocaleString('zh-CN', {
					year: 'numeric',
					month: '2-digit',
					day: '2-digit',
					hour: '2-digit',
					minute: '2-digit',
					second: '2-digit',
				});
			},
			handleLock() {
				this.confirmAction = '关锁';
				this.showConfirmDialog = true;
				this.pendingOperation = () => this.updateStatus(true);
			},
			handleUnlock() {
				this.confirmAction = '开锁';
				this.showConfirmDialog = true;
				this.pendingOperation = () => this.updateStatus(false);
			},
			confirmOperation() {
				if (this.pendingOperation) {
					this.pendingOperation();
					this.showConfirmDialog = false;
					this.pendingOperation = null;
				}
			},
			//----------------------------------------------------------------------------------------------------------------------------------------------
			//震动模式
			toggleVibration(newValue) {
				this.queryPruchasedPackages()
				this.vibrationEnabled = newValue
				if (newValue) { //长摇 震动 开启
					this.generatePulseBirdLongSwayModelTail_h5() //开始震动
				} else {
					this.generatePulseBirdStopAllShakeTail_h5() //停止震动
				}
			},
			selectVibrationMode(mode) { //震动模式的选择
				this.queryPruchasedPackages()
				this.vibrationMode = mode;
				if (this.vibrationEnabled) {
					this.generatePulseBirdLongSwayModelTail_h5() //开始震动
				}
			},
			generatePulseBirdLongSwayModelTail_h5() { //开始震动
				//this.isDataLoading = true;
				axios.post(this.$p_url + '/feign/toyShakeMetalLockBluetooth/h5/getShakeMetalLockImmediatelyShakeCmd', {
						toyId: this.toyId,
						userId: this.receiverID,
						shakeIntensity: this.vibrationIntensity, //震动强度
						shakeModel: this.vibrationMode ,//震动模式
						shakeDuration: 9999 ,//震动时长
					}, {
						withCredentials: true,
						headers: {
							'Content-Type': 'application/json',
							'Accept': '*/*',
							'token': Cookies.get("token"),
							'webId': this.uuid,
						},
					})
					.then(response => {
						this.isDataLoading = false;
						console.log("开始震动：", response.data)
						const state = response.data.state; // 获取状态
						if (state === "success") { // 检查状态
							this.command = response.data.data
							this.pushMsgToApp("mqtt_h5_100002") //推送
						}
						if (state === "failed") {
							this.open4(this.$t('language000430'))
						}
					})
					.catch(error => { // 请求失败时处理错误
						this.isDataLoading = false;
						console.error('Error fetching data:', error);
					});
			},
			//----------------------------------------------------------------------------------------------------------------------------------------------
			//线性震动
			linearOpening(newValue) {
				this.queryPruchasedPackages()
				this.linearVibrationEnabled = newValue
				if (newValue) { //线性 震动 开启
					this.generatePulseBirdLineSwayModelTail_h5() //开始震动
				} else {
					this.generatePulseBirdStopAllShakeTail_h5() //停止震动
				}
			},
			handleLinearVibrationChange(event) {
				this.queryPruchasedPackages()
				this.linearVibrationIntensity = parseInt(event.target.value); //转换为整数，因为 range input 的值是字符串
				if (this.linearVibrationEnabled) {
					this.generatePulseBirdLineSwayModelTail_h5() //开始震动
				}
			},
			generatePulseBirdLineSwayModelTail_h5() { //线性震动
				//this.isDataLoading = true;
				axios.post(this.$p_url + '/feign/toyShakeMetalLockBluetooth/h5/getLineModelShakeCmd', {
						toyId: this.toyId,
						userId: this.receiverID,
						lineSpeedValue: this.linearVibrationIntensity, //速度值
					}, {
						withCredentials: true,
						headers: {
							'Content-Type': 'application/json',
							'Accept': '*/*',
							'token': Cookies.get("token"),
							'webId': this.uuid,
						},
					})
					.then(response => {
						this.isDataLoading = false;
						console.log("线性震动：", response.data)
						const state = response.data.state; // 获取状态
						if (state === "success") { // 检查状态
							this.command = response.data.data
							this.pushMsgToApp("mqtt_h5_100002") //推送
						}
						if (state === "failed") {
							this.open4(this.$t('language000430'))
						}
					})
					.catch(error => { // 请求失败时处理错误
						this.isDataLoading = false;
						console.error('Error fetching data:', error);
					});
			},
			//----------------------------------------------------------------------------------------------------------------------------------------------
			//停止震动 发送mqtt给APP
			generatePulseBirdStopAllShakeTail_h5() { //停止震动
				//this.isDataLoading = true;
				axios.post(this.$p_url + '/feign/toyShakeMetalLockBluetooth/h5/stopAllShakeAndElectricCmd', {
						toyId: this.toyId,
						userId: this.receiverID
					}, {
						withCredentials: true,
						headers: {
							'Content-Type': 'application/json',
							'Accept': '*/*',
							'token': Cookies.get("token"),
							'webId': this.uuid,
						},
					})
					.then(response => {
						this.isDataLoading = false;
						console.log("停止震动：", response.data)
						const state = response.data.state; // 获取状态
						if (state === "success") { // 检查状态
							this.command = response.data.data
							this.pushMsgToApp("mqtt_h5_100002") //推送
						}
						if (state === "failed") {
							this.open4(this.$t('language000430'))
						}
					})
					.catch(error => { // 请求失败时处理错误
						this.isDataLoading = false;
						console.error('Error fetching data:', error);
					});
			},
			//----------------------------------------------------------------------------------------------------------------------------------------------
			//推送
			pushMsgToApp(mqttType) { //推送给APP
				//this.isDataLoading = true;
				axios.post(this.$p_url + '/feign/oem/pulseBird/h5/pushMsgToApp', {
						toyUid: this.toyId,
						receiverID: this.receiverID,
						command: this.command,
						mqttType: mqttType
					}, {
						withCredentials: true,
						headers: {
							'Content-Type': 'application/json',
							'Accept': '*/*',
							'token': Cookies.get("token"),
							'webId': this.uuid,
						},
					})
					.then(response => {
						this.isDataLoading = false;
						console.log("推送给APP：", response.data)
						const state = response.data.state; // 获取状态
						if (state === "success") { // 检查状态

						}
					})
					.catch(error => { // 请求失败时处理错误
						this.isDataLoading = false;
						console.error('Error fetching data:', error);
					});
			},
			open2(string) {
				this.$message({
					message: string,
					type: 'success'
				});
			},
			open4(string) {
				this.$message.error(string);
			},
			//...
		},
	};
</script>

<style scoped>
	/* 主容器和布局 */
	.lock-control-container {
		background-color: #f7fafc;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		padding-top: 5rem;
		padding-left: 1rem;
		padding-right: 1rem;
	}

	.lock-control-content {
		width: 100%;
		max-width: 32rem;
		margin: 0 auto;
		text-align: center;
	}
	
	.status-text {
		font-size: 2.25rem;
		font-weight: 700;
	}

	.status-text-locked {
		color: #dc2626;
	}

	.status-text-unlocked {
		color: #16a34a;
	}

	/* 按钮区域 */
	.button-area {
		display: flex;
		justify-content: center;
		align-items: center;
		gap: 4rem;
		/* 16 spaced */
	}

	.control-button {
		width: 10rem;
		height: 10rem;
		display: flex;
		align-items: center;
		justify-content: center;
		color: white;
		box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
		transition: transform 0.3s ease;
		/* 动画效果 */
		border-radius: 9999px;
		/* !rounded-button */
		white-space: nowrap;
	}

	/* 按钮悬停和点击特效 */
	.control-button:not(.button-disabled):hover {
		transform: scale(1.05);
	}

	.control-button:not(.button-disabled):active {
		transform: scale(0.95);
	}

	.button-disabled {
		opacity: 0.5;
		cursor: not-allowed;
	}

	.open-button {
		background-image: linear-gradient(to bottom right, #4ade80, #16a34a);
	}

	.close-button {
		background-image: linear-gradient(to bottom right, #f87171, #dc2626);
	}

	.button-content {
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.icon {
		font-size: 2.25rem;
		margin-bottom: 0.5rem;
	}

	.button-label {
		font-size: 1.25rem;
		font-weight: 500;
	}

	/* 确认弹窗 */
	.confirm-dialog-overlay {
		position: fixed;
		inset: 0;
		background-color: rgba(0, 0, 0, 0.5);
		display: flex;
		align-items: center;
		justify-content: center;
		z-index: 50;
	}

	.confirm-dialog-box {
		background-color: white;
		border-radius: 0.5rem;
		padding: 1.5rem;
		width: 20rem;
	}

	.dialog-title {
		font-size: 1.25rem;
		font-weight: 600;
		margin-bottom: 1rem;
	}

	.dialog-message {
		color: #4b5563;
		margin-bottom: 1.5rem;
	}

	.dialog-actions {
		display: flex;
		justify-content: flex-end;
		gap: 1rem;
	}

	.dialog-button {
		padding-left: 1rem;
		padding-right: 1rem;
		padding-top: 0.5rem;
		padding-bottom: 0.5rem;
		border-radius: 9999px;
		white-space: nowrap;
		transition-property: background-color;
		transition-duration: 0.2s;
	}

	.cancel-button {
		background-color: #e5e7eb;
		color: #4b5563;
	}

	.cancel-button:hover {
		background-color: #d1d5db;
	}

	.confirm-button {
		background-color: #3b82f6;
		color: white;
	}

	.confirm-button:hover {
		background-color: #2563eb;
	}

	input[type="range"] {
		-webkit-appearance: none;
		appearance: none;
		background: transparent;
		cursor: pointer;
	}

	input[type="range"]::-webkit-slider-runnable-track {
		background: #ddd;
		height: 8px;
		border-radius: 4px;
	}

	input[type="range"]::-webkit-slider-thumb {
		-webkit-appearance: none;
		appearance: none;
		margin-top: -4px;
		background-color: #3b82f6;
		height: 16px;
		width: 16px;
		border-radius: 50%;
	}

	input[type="range"]:focus {
		outline: none;
	}

	input[type="range"]::-moz-range-track {
		background: #ddd;
		height: 8px;
		border-radius: 4px;
	}

	input[type="range"]::-moz-range-thumb {
		border: none;
		border-radius: 50%;
		background-color: #3b82f6;
		height: 16px;
		width: 16px;
	}
</style>